module.exports = __webpack_public_path__ + "static/TruenoUltLt-3d56afa77683914ace6f835ce40d82ac.woff";